export const recentFormatter = ({ searchResult, handleRecentSelected }) => {
    return {
        title: searchResult.name,
        name: searchResult.name,
        variant: searchResult.variant,
        ariaLabel: `Recent search: ${searchResult.name}`,
        onSelect: () => handleRecentSelected(searchResult.name),
    };
};
